module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.activetagLoading),
      expression: "activetagLoading",
      modifiers: {
        "opacity": true
      }
    }]
  }, [_c('div', {}, [_c('div', {
    staticClass: "inline plate-box"
  }, [_c('p', {
    staticClass: "cell-plate info-car"
  }, [_c('span', [_vm._v(_vm._s(_vm.vehicle.plate))])])]), _vm._v(" "), _c('p', {
    staticClass: "inline bold border-right-gray"
  }, [_vm._v(_vm._s(_vm.vehicle.brandName))]), _vm._v(" "), (_vm.completeData) ? _c('p', {
    staticClass: "inline bold margin-b0"
  }, [_vm._v(_vm._s(_vm.vehicle.modelName))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tag-box"
  }, [(!_vm.linkedTag) ? _c('div', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("N° TAG")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "only-numbers",
      rawName: "v-only-numbers"
    }, {
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.serialNumber),
      expression: "serialNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "data-vv-rules": "required|numeric"
    },
    domProps: {
      "value": (_vm.serialNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.serialNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": String(_vm.serialNumber).length == 0 || !_vm.serialNumber,
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.vincularTag()
      }
    }
  }, [_vm._v("Ativar")])]) : (_vm.linkedTag == 'success') ? _c('div', {
    staticClass: "alert alert-success"
  }, [_c('p', {
    staticClass: "no-margin"
  }, [_vm._v("N° TAG: " + _vm._s(_vm.serialNumber))])]) : _c('div', [_c('div', {
    staticClass: "alert alert-danger inline"
  }, [_c('p', [_vm._v(_vm._s(_vm.msg))])]), _vm._v(" "), _c('button', {
    staticClass: "no-btn",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.linkedTag = !_vm.linkedTag
      }
    }
  }, [_c('i', {
    staticClass: "icon-repeat"
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-b415c90e!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/aggregate/modal/aggregate-register/tag.vue
// module id = 2202
// module chunks = 1